import { WebAppProviders } from '@pidelo/web-ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { api, queryClient } from './app/core.ts';
import { router } from './app/router.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WebAppProviders client={api} queryClient={queryClient}>
      <RouterProvider router={router} />
    </WebAppProviders>
  </StrictMode>,
);
